import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';

export const mutations = {
    [MUTATIONS.SET_SITE](state, site) {
        if (!state.sites[site.uuid]) {
            Vue.set(state.sites, site.uuid, site);
        }
        Object.assign(state.sites[site.uuid], site);
    },

    [MUTATIONS.SET_ACTIVE_SITE](state, site_uuid) {
        state.active_site_uuid = site_uuid;
    },
};
